export interface lonGetMortgageAgreement {
    /** 여신상담품의번호
     * @type {string}
     */
    lonCnslCnlnNo: string
    /** 상담품의일련번호
     * @type {string}
     */
    csncsSrn: string
    /** 차주고객명
     * @type {string}
     */
    dbtoCsm: string
    /** 비대면동의대상상품종류코드 (01 : 주택담보대출 / 02: 전세대출)
     * @type {string}
     */
    nofcCosnTgtPdfKcd: string
    /** 차주고객명
     * @type {string}
     */
    hsmmNm: string
}

export const initialState: lonGetMortgageAgreement = {
    lonCnslCnlnNo: '',
    csncsSrn: '',
    dbtoCsm: '',
    nofcCosnTgtPdfKcd: '',
    hsmmNm: '',
}
